export class CalculateQuotaRequest {
    public routeLength: number;
    public dates: Date[];
    public segmentLength: number;
    public snapshotsPerDay: number;
    public historicDayCount: number;
    public calculateSpectogram: boolean;
    public calculateBudgetSpectrogram: boolean;
    public calculateHistorical: boolean;
    public branchingAnalyse: boolean;

    constructor();
    constructor(routeLength: number, dates: Date[], segmentLength: number, snapshotsPerDay: number, historicDayCount: number, calculateSpectogram: boolean, calculateBudgetSpectrogram: boolean, calculateHistorical: boolean, branchingAnalyse: boolean);
    constructor(routeLength?: number, dates?: Date[], segmentLength?: number, snapshotsPerDay?: number, historicDayCount?: number, calculateSpectogram?: boolean, calculateBudgetSpectrogram?: boolean, calculateHistorical?: boolean, branchingAnalyse?: boolean) {
        if (routeLength) {
            this.routeLength = routeLength;
            this.dates = dates;
            this.segmentLength = segmentLength;
            this.snapshotsPerDay = snapshotsPerDay;
            this.historicDayCount = historicDayCount;
            this.calculateSpectogram = calculateSpectogram;
            this.calculateBudgetSpectrogram = calculateBudgetSpectrogram;
            this.calculateHistorical = calculateHistorical;
            this.branchingAnalyse = branchingAnalyse;
        }
    }
}

export class CalculateQuotaResponse {
    public requestsPerDay: number;
    public shortage: number;
    public quotaInsufficient: boolean;

    constructor();
    constructor(json: any);
    constructor(json?: any) {
        if (json) {
            this.requestsPerDay = json.requestsPerDay;
            this.shortage = json.shortage;
            this.quotaInsufficient = json.quotaInsufficient;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/calculateQuota.ts